import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LoadingComponent from "../components/LoadingComponent.jsx";
import InfoRow from "../components/InfoRow.jsx";
import { useNavigate } from "react-router-dom";
import { useAdminDetail } from "../hooks/useAdminDetail.jsx";

const SELLER_CHANNEL_LABELS = {
  mercado_libre: "Mercado Libre",
  shopify: "Shopify",
  woocommerce: "WooCommerce",
  bootic: "Bootic",
  vtex: "VTEX",
  jumpseller: "Jumpseller",
  bsale: "Bsale",
};

const ADDON_LABELS = {
  dashboard: "Dashboard",
  dashboard_pro: "Dashboard Pro",
  api_access: "API Access",
  cx_support: "CX Support",
  seller_channels_enabled: "Seller Channels",
  fulfillment_lite: "Fulfillment Lite",
  fulfillment_pro: "Fulfillment Pro",
};

function AdminDetail() {
  const { admin, loading, error, updateAdminPlan } = useAdminDetail();
  const navigate = useNavigate();

  if (loading) return <LoadingComponent />;

  if (!admin) {
    return (
      <Box sx={{ p: 3 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
          Regresar
        </Button>
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography color="text.secondary">
            No se encontraron datos del admin.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <>
      {error && (
        <Alert sx={{ borderRadius: "0px !important" }} severity="error">
          {error}
        </Alert>
      )}

      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
          Regresar
        </Button>

        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            <Card elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                  {admin.user?.first_name} {admin.user?.last_name}
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <InfoRow mb={1} label="ID">{admin.id}</InfoRow>
                <InfoRow mb={1} label="Email">{admin.user?.email}</InfoRow>
                <InfoRow mb={1} label="RUT">{admin.rut}</InfoRow>
                <InfoRow mb={1} label="Plan">
                  {admin.plan_name ? (
                    <Chip label={admin.plan_name} size="small" variant="outlined" />
                  ) : (
                    "—"
                  )}
                </InfoRow>
                <InfoRow mb={1} label="País">
                  {admin.country_fk?.name ?? "—"}
                </InfoRow>
                <InfoRow mb={1} label="Creación">
                  {admin.created_at
                    ? new Date(admin.created_at).toLocaleString()
                    : "—"}
                </InfoRow>
                <InfoRow mb={1} label="Último Login">
                  {admin.user?.last_login
                    ? new Date(admin.user.last_login).toLocaleString()
                    : "—"}
                </InfoRow>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {admin.admin_plan && (
          <Grid container spacing={3} sx={{ mt: 0 }}>
            <Grid item xs={12} md={6}>
              <Card elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                    Seller Channels
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={1}>
                    {Object.entries(admin.admin_plan.seller_channels).map(([key, value]) => (
                      <Grid item xs={12} sm={6} key={key}>
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              checked={value}
                              onChange={(e) =>
                                updateAdminPlan("seller_channels", key, e.target.checked)
                              }
                            />
                          }
                          label={SELLER_CHANNEL_LABELS[key] ?? key}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                    Addons
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={1}>
                    {Object.entries(admin.admin_plan.addons).map(([key, value]) => (
                      <Grid item xs={12} sm={6} key={key}>
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              checked={value}
                              onChange={(e) =>
                                updateAdminPlan("addons", key, e.target.checked)
                              }
                            />
                          }
                          label={ADDON_LABELS[key] ?? key}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
}

export default AdminDetail;
